export { createEpicMiddleware } from './createEpicMiddleware';
export { ActionsObservable } from './ActionsObservable';
export { combineEpics } from './combineEpics';
export { EPIC_END } from './EPIC_END';
export { ofType } from './operators';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-observable/lib/esm/index.js
// module id = 1393
// module chunks = 0